import { AmenityListItem } from '@/api/reservations/get-amenities'

export const matchesSearch = (amenity: AmenityListItem, search: string) =>
  amenity.name.toLowerCase().includes(search) ||
  amenity.locations.some((location) => location.name.toLowerCase().includes(search))
